import { importer_context_params } from '../types';

export const createDefaultImporterContextValue = (defaultValue: importer_context_params | undefined = undefined) =>
    defaultValue;

export default createDefaultImporterContextValue;
